import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { TelephonePrefix } from '@types'

import { getTelephonePrefixes } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los prefijos telefónicos',
  })
}

const useGetTelePhonePrefixes = () => {
  const { data, isLoading } = useQuery(QUERY_KEYS.TELEPHONE_PREFIXES, getTelephonePrefixes, {
    onError,
    refetchOnWindowFocus: false,
  })

  return {
    telephonePrefixes: data
      ? (data.telephonePrefixes as TelephonePrefix[])
      : ([] as TelephonePrefix[]),
    isLoading,
  }
}

export { useGetTelePhonePrefixes }
